import React from "react";

function SocialMediaButton({ data }) {
    return (
        <span key={data.documentId} className="social-media-button">
            <a target="_blank" href={data.link.url}>
                <img alt={data.logo.alternativeText} className="social-media-icons img-responsive"
                     src={data.logo.url}/>
            </a>
        </span>
    );
}

export default SocialMediaButton;
